import { COMPONENTS_ARTICLES } from "components/Articles/Articles";
import { __callbacks } from "Utils/Callbacks/Callback";
import { AppState } from "Utils/Enums";
import { ICollectionItem } from "Utils/Interfaces";
import React, { useRef } from "react";
import { ReactNode, useEffect, useState } from "react";
import ButtonBack from "../ButtonBack/ButtonBack";
import styles from "./WindowArticle.module.scss";

export default function WindowArticle(props: any) {

  const [item, setItem] = useState<ICollectionItem | null>(null);
  const [articleNode, setArticleNode] = useState<ReactNode | null>(null);
  const [classHide, setClassHide] = useState(styles["hide-right"]);

  const body = useRef<any>(null);

  useEffect(() => {
    __callbacks.onArticleClick((data: ICollectionItem) => {
      setItem({ ...data });
      setClassHide("");
      // reset scroll to top
      body.current.scrollTop = 0;
    });
  }, []);


  useEffect(() => {
    if (!item) return;

    // create element
    const articleElement = React.createElement((COMPONENTS_ARTICLES as any)[item.articleComponentName]);
    setArticleNode(articleElement);
  }, [item]);

  const onClickBackButton = () => {
    setClassHide(styles["hide-right"]);
  }


  return (
    <>
      <div className={`${styles.container} ${classHide}`}>
        <div className={`${styles.header}`}>
          <div className={styles["container-content"]}>
            <div className={styles["container-btn-back"]} onClick={onClickBackButton}>
              <ButtonBack backState={AppState.home} black></ButtonBack>
            </div>
            <div className={styles["title"]}>
              {item?.title}
            </div>
          </div>
        </div>
        <div ref={body} className={styles.body}>
          {/* body {item?.title} */}
          {articleNode}
        </div>
      </div>
      <div className={`${styles["container-wrapper"]} ${classHide ? (styles["container-wrapper-hide"]) : ("")
        }`}></div>
    </>
  )
}
